<template>
    <div>
      <Header />
      <main class="app-content">
        <div class="app-title">
          <div>
            <h1><i class="fa fa-dashboard"></i>Dosya Bilgileri Ekranı</h1>
          </div>
  
          <ul class="app-breadcrumb breadcrumb">
            <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
            <li class="breadcrumb-item"><a href="#">Dosya Bilgileri</a></li>
          </ul>
        </div>
        <div class="row form-margin">
          <div class="col-md-12 tex-center d-flex align-items-center flex-column">
            <div class="tile">
              <h3 class="tile-title">Dosya Bilgileri</h3>
              <div class="tile-body">
                <form>
                  <div class="form-group">
                    <label class="control-label">Dosya Adı:</label>
                    <label class="form-control">{{ result.filename }}</label>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Dosya Açıklaması:</label>
                    <label class="form-control">{{ result.filecontent }}</label>
                  </div>
  
                  <div class="form-group">
                    <label class="control-label">Dosya Linkine Tıklayarak Ulaşabilirsiniz:</label>
                    <a style="background-color: #f6f1f1;font-size:20px;text-align:center" :href="result.fullpath" target="_blank" class="form-control">{{ result.pathname }}</a>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Sınıf:</label>
                    <label class="form-control">{{ result.class }}</label>
                  </div>
         
                  <div class="form-group">
                    <label class="control-label">Yüklenme Tarihi:</label>
                    <label class="form-control">{{ result.reg_date }}</label>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>
  
      <Sidebar />
    </div>
  </template>
  
  <script>
  import Header from "./default/Header";
  import Sidebar from "./default/Sidebar";
  import axios from "axios";
  import store from "../store";
  export default {
    data() {
      return {
        result: {
          id: "",
          filename: "",
          filecontent: "",
          class: "",
          pathname: "",
          fullpath: "",
          userId: "",
          userNameSurname: "",
          img_url: "",
          imgSrc: store.state.img_base_url,
        },
        noteId: this.$route.query.id,
      };
    },
    methods: {

    },
    mounted: function() {
      window.scrollTo(0, 0);
      var token = localStorage.getItem("token");
      if(!token){
        this.$router.push("/");
      }
      var datas = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
        noteId: this.noteId,
      };
  
      let dataUrl =
        store.state.base_url + "User/getByNoteDetail.php?key=123";
      return axios.post(dataUrl, JSON.stringify(datas)).then((response) => {
        this.datas = response.data.data;
        this.userData = response.data.user;
        this.result.id = this.datas.id;
        this.result.filename = this.datas.filename;
        this.result.filecontent = this.datas.filecontent;
        this.result.pathname = this.datas.pathname;
        this.result.fullpath ="https://www.file.dosya.aslanyazilimm.com/Notes/"  + this.datas.pathname;
        this.result.class = this.datas.class;
        this.result.reg_date = this.datas.reg_date;
      });
    },
    components: {
      Header,
      Sidebar,
    },
  };
  </script>
  


// WEBPACK FOOTER //
// src/components/NotesShow.vue